import { Button, Row } from 'antd';
import PermissionsWrapper from 'app/components/PermissionsWrapper/PermissionsWrapper';
import TaskListFilters from 'app/containers/Task/parts/TaskListFilters/TaskListFilters';
import TaskListTable from 'app/containers/Task/parts/TaskListTable/TaskListTable';
import { useTaskSlice } from 'app/containers/Task/slice';
import { selectSingleFieldTaskListState } from 'app/containers/Task/slice/selectors';
import { ITaskFilters, TaskListSort } from 'app/containers/Task/slice/types';
import { PermissionsEnum } from 'app/containers/User/slice/types';
import { RouteConstants } from 'app/routes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

import * as S from './FieldTasks.styles';

interface IProps {
  envId: number;
  fieldId: number;
}

const FieldTasks = ({ envId, fieldId }: IProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const history = useHistory();
  const { actions: taskActions } = useTaskSlice();
  const fieldTaskListState = useSelector(selectSingleFieldTaskListState);

  const createTaskOnField = () => {
    history.push(
      generatePath(RouteConstants.field.createTaskOnField, {
        envId,
        fieldId,
      }),
    );
  };

  const setFilters = (filters: ITaskFilters) => {
    dispatch(taskActions.setFieldTaskListFilters(filters));
  };

  const setCurrentPage = (page: number) => {
    dispatch(taskActions.setFieldTaskListCurrentPage(page));
  };

  const setSort = (payload: TaskListSort) => {
    dispatch(taskActions.setFieldTaskListSort(payload));
  };

  return (
    <S.TasksCard
      title={t('Field.TasksTable.TaskList', 'Task list')}
      extra={[
        <PermissionsWrapper
          key="0"
          requiredEditPermissions={[PermissionsEnum.taskAdministration]}
        >
          <Button type="primary" onClick={createTaskOnField}>
            {t('Field.TasksTable.CreateTask', 'Create task')}
          </Button>
        </PermissionsWrapper>,
      ]}
    >
      <Row style={{ marginBottom: 20 }}>
        <TaskListFilters
          fieldId={fieldId}
          layout="inline"
          currentPage={fieldTaskListState.currentPage}
          sort={fieldTaskListState.sort}
          filters={fieldTaskListState.filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
        />
      </Row>
      <TaskListTable
        fieldId={fieldId}
        taskListState={fieldTaskListState}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
        setSort={setSort}
      />
    </S.TasksCard>
  );
};

export default FieldTasks;
